// extracted by mini-css-extract-plugin
module.exports = {"InputErrorMessage":"InputErrorMessage_InputErrorMessage__UTZXB","error":"InputErrorMessage_error__AEpK3"};